import { createFileRoute } from "@tanstack/react-router";
import RoofRepair from "@/pages/services/RoofRepair";
import { seo, breadcrumbSchema, absoluteUrl } from "@/lib/seo";
import { buildFaqPageSchema, buildServiceSchema } from "@/lib/schema";
import { roofRepairFaqs } from "@/data/serviceFaqs";

export const Route = createFileRoute("/_site/services/roof-repair")({
  head: () =>
    seo({
      title: "Roof Repair in Minneapolis, MN | Cedar Creek Construction",
      description:
        "Fast, reliable roof repair in Minneapolis & the Twin Cities—leaks, storm and hail damage, missing shingles, and flashing. Licensed local crew. Free estimates: (612) 298-9865.",
      path: "/services/roof-repair",
      jsonLd: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Services", path: "/roofing" },
          { name: "Roof Repair", path: "/services/roof-repair" },
        ]),
        buildServiceSchema({
          name: "Roof Repair in Minneapolis, MN",
          serviceType: "Roof Repair",
          url: absoluteUrl("/services/roof-repair"),
          description:
            "Roof leak repair, storm and hail damage repair, shingle replacement, and flashing repair for homes across Minneapolis and the Twin Cities metro.",
        }),
        buildFaqPageSchema(roofRepairFaqs),
      ],
    }),
  component: RoofRepair,
});
